import { useMutation } from '@tanstack/react-query';

import { generatePdfOfAdvisoryReportById } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useGenerateAdvisoryPdfLink() {
  return useMutation({
    mutationFn: (id: string) =>
      generatePdfOfAdvisoryReportById(
        {
          params: {
            path: { report_id: id },
            query: {},
          },
        },
        wgApi,
      ),
  });
}
